﻿import { EnumLogLevel } from "./EnumLogLevel";
export class LogMsg {
    
    static Name = "LogMsg";
    constructor() {
        this.Source = "";
        this.Message = "";
        this.Level = EnumLogLevel.Info;
        this.MessageTime = "";
    }

    

    Source: string;
    Message: string;
    Level: EnumLogLevel;
    MessageTime: string;
}
